import { useContext } from "react";
import { useQuery } from "react-query";
import { ITimelineInput, ITimelineOutput } from "../../../api-schema/timeline";
import { AuthContext } from "../contexts/AuthProvider";
import { getRequest } from "./apiClient";

const TIMELINE_ENDPOINT = "timeline";
const formatDate = (date: Date) =>
  `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;

const buildTimelineCacheKey = ({
  bId,
  startAt,
  interval,
  amount,
}: ITimelineInput) => [
  TIMELINE_ENDPOINT,
  bId,
  formatDate(startAt),
  interval,
  amount,
];

const getTimelineData = async (
  { bId, startAt, interval, amount }: ITimelineInput,
  token: string
): Promise<ITimelineOutput> => {
  // FIXME 時差や時間
  const formattedStartAt = formatDate(startAt);

  const result = await getRequest<ITimelineOutput>(
    TIMELINE_ENDPOINT,
    {
      bId,
      startAt: formattedStartAt,
      interval,
      amount,
    },
    token
  );
  return result;
};

/**
 * タイムラインデータを返す。
 * @param  {
    bId: string;
    startAt: Date;
    interval: "day" | "week" | "month" | "year";
    amount: number;
}
 * @returns
 */
const useTimelineData = (input: ITimelineInput) => {
  const { token } = useContext(AuthContext);
  const { data, isLoading, isError } = useQuery<ITimelineOutput>(
    buildTimelineCacheKey(input),
    () => getTimelineData(input, token)
  );
  return { data, isLoading, isError };
};

export default useTimelineData;
